// extracted by mini-css-extract-plugin
export default {"terms_content":"terms_terms_content__0oTir","terms_heading":"terms_terms_heading__wHMkm"};